import { Component } from '@angular/core';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { UserLicenseComponent } from './user-license/user-license.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-user-profile',
  imports: [PersonalInformationComponent, ChangePasswordComponent, UserLicenseComponent, MaterialModule, TranslateModule],
  templateUrl: './user-profile.component.html'
})
export class UserProfileComponent {
  constructor(private router: Router, private authService: AuthService) {}

  get isAdmin() {
    return this.router.url.startsWith('/admin');
  }

  get hasCompany() {
    return !!this.authService.userInfo?.companyId;
  }
}
